module.exports = __webpack_public_path__ + "media/images/muted-dash-9e452c9de0f8c3adfa9003ee9f5722b9.png";